.pdpReviewsSection {
  background-color: var(--colors-background);
  scroll-margin-top: 100px;
}

.pdpSection {
  background-color: var(--colors-grays-ultralight);
}

@media all and (--reefer-media-tablet-min) {
  .pdpSection {
    background-color: unset;
    padding-top: 16px;
  }

  .pdpReviewsSection {
    background-color: unset;
    display: grid;
    grid-template-columns: 360px minmax(100%, 640px);
    gap: 48px;
    margin-left: auto;
    margin-right: auto;
    align-items: start;
    margin-top: 100px;
  }

  .pdpReviewsListSection {
    max-width: calc(100% - 360px);
  }
}
